import React from "react";
import logo from '../../static/media/logo.svg' //img import

//handleCopy Mehtod
const handleCopy = (e, link,el_class="") => {
    e.preventDefault(); //prevents refresh
    navigator.clipboard.writeText(link);  //copys text to clipboard
    if (window.innerWidth < 991) {
      document.querySelector(`.${el_class}`).style.display = "block";

      setTimeout(() => {
        document.querySelector(`.${el_class}`).style.display = "none";
      }, 1500);
    } else {
      document.querySelector('.btn_txt').innerText = "Copied!"

      setTimeout(() => {
        document.querySelector('.btn_txt').innerHTML = "Copy"
      }, 1500);
    }
  };

function MicroSiteNav({ nft, styles }) {
  return (
    <div>
      <div className={styles.microsite_nav}>
        <div className={styles.logo}>
          <img src={logo} alt="Dehidden-logo" />
        </div>
      </div>
      <div className={styles.right_nav}>
        <div className={styles.linkbar}>
          <div className={styles.linkbar_text}>
            {nft.url}
          </div>
          <button className={`${styles.button} ${styles.primary}`} onClick={(e) =>
              handleCopy(
                e,
                `${nft.url}`
              )
            }>
          <i class="fa fa-copy"></i>
          <span className="btn_txt">Copy</span>
          </button>
        </div>
        <div
          className={styles.mobile_copy}
          onClick={(e) =>
            handleCopy(e, `${nft.url}`, `${styles.copytext_mobile}`)
          }> <i class="fas fa-copy"></i> </div>
        <div className={styles.copytext_mobile}>Copied to Clipboard !</div>
      </div>
    </div>
  );
}

export default MicroSiteNav;
